// "homepage": "https://dev2417.d33wqvysdmjcsg.amplifyapp.com/#/",

import React, { useEffect, useState } from "react";

// Dependencies
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import CoinbaseWalletSDK from "@coinbase/wallet-sdk";
import axios from "axios";
import { MerkleTree } from "merkletreejs";
import keccak256 from "keccak256";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Components
import Scroller from "./components/Scroller";
import NavigationBar from "./components/NavigationBar";

// Pages
import Landing from "./pages/Landing";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import FAQs from "./pages/FAQs";
import Roadmap from "./pages/Roadmap";
import Team from "./pages/Team";
import Mint from "./pages/Mint";
import MyNFTs from "./pages/MyNFTs";
import Admin from "./pages/Admin";

// App
const App = () => {
  // Sates
  const [language, setLanguage] = useState("english");

  const [walletConnected, setWalletConnected] = useState(false);
  const [totalMinted, setTotalMinted] = useState(0);
  const [mintQuantity, setMintQuantity] = useState(1);

  const [myNFTs, setMyNFTs] = useState([]);

  const [revealNFT, setRevealNFT] = useState({
    tokenID: undefined,
    revealing: false,
    revealed: false,
  });

  // DAPP - Functions
  useEffect(() => {
    // axios
    //   .get(
    //     `https://api.etherscan.io/api?module=stats&action=tokensupply&contractaddress=0x71C6f27A537A81d2329eFa619a78FD6e46c9d7A0&apikey=4FZDPMBA2BED6JBPHWRJFUDQXYP9AQQ1HM`
    //   )
    //   .then(function (response) {
    //     setTotalMinted(response.data.result);
    //   });

    axios
      .get(
        `https://api.polygonscan.com/api?module=stats&action=tokensupply&contractaddress=0x71C6f27A537A81d2329eFa619a78FD6e46c9d7A0&apikey=89RW21E8FGGY676DDKA2AN9Y8VX7NC6VHA`
      )
      .then(function (response) {
        setTotalMinted(response.data.result);
      });
  }, []);

  const connectWallet = async () => {
    window.localStorage.clear();

    if (Web3.givenProvider) {
      const providerOptions = {
        walletconnect: {
          package: WalletConnectProvider,
          options: {
            infuraId: "4aab2323b48d4c36b1f439e83ab073d2",
          },
        },
        coinbasewallet: {
          package: CoinbaseWalletSDK,
          options: {
            appName: "Multi Wallet Auth DAPP",
            infuraId: "4aab2323b48d4c36b1f439e83ab073d2",
            chainId: 1,
          },
        },
      };

      const web3Modal = new Web3Modal({
        network: "mainnet",
        cacheProvider: true,
        providerOptions,
      });

      const provider = await web3Modal.connect();
      const web3 = new Web3(provider);

      web3.eth.net.getId();

      const accounts = await web3.eth.getAccounts();
      const account = accounts[0];

      const { ethereum } = window;

      const networkId = await ethereum.request({
        method: "net_version",
      });

      // if (networkId === 1 || networkId === `${1}`) {
      //   setWalletConnected(true);
      // } else {
      //   toast.error(`Please change your network to Ethereum Mainnet`);

      //   await web3.currentProvider.request({
      //     method: "wallet_switchEthereumChain",
      //     params: [{ chainId: Web3.utils.toHex(1) }],
      //   });

      //   setWalletConnected(true);
      // }

      if (networkId === 137 || networkId === `${137}`) {
        setWalletConnected(true);
      } else {
        toast.error(`Please change the network to Polygon Mainnet`);

        let updatedPrimaryNetwork = {
          chainId: 137,
          chainName: "Polygon Mainnet",
          nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
          },
          rpcUrls: ["https://polygon-rpc.com/"],
          blockExplorerUrls: ["https://polygonscan.com/"],
        };

        updatedPrimaryNetwork.chainId = `0x${Number(
          updatedPrimaryNetwork.chainId
        ).toString(16)}`;

        await ethereum.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              ...updatedPrimaryNetwork,
            },
          ],
        });

        setWalletConnected(true);
      }
    } else {
      window.open(`https://metamask.app.link/dapp/${window.location.href}`);
    }
  };

  const whitelistSaleMint = async () => {
    const WHITELIST_SALE_WHITELIST = [
      "0x5c8B242Ff83Ca756Fe8565e0202B8E78Fd4127D9",
      "0x48632368E9744484340B7A3E0A70CcBBe66A9B58",
      "0x6FfEbe1BcE99023375788dC512E4a5f7Fc11cCFB",
      "0xBC4Ce6d19d8413745Ed912E715dFcf39a55e5bd0",
      "0xE53eb6eDf8417b2733B721acDE61A6cab9495A8a",
      "0x16dC6Ef866C32Ce7989fdcC9F05FE990Ed7e42BB",
      "0xfCa8664Fe3870FC2481aDD0c9b096F11dEe39098",
      "0x77fF15a365049839d74dA8F2821C89f4f5178C28",
      "0xb3F7cf46ade4BC42d4CA6061Da56863A105Bd7a2",
      "0x9Cb02ddD1BA1A1C2B39b66763693A6C376A0A794",
      "0x4312ADAC5212306F59722Fc021cedF6302cE6A5D",
      "0xeAEf0A322F5B5b07a6993859eB643f401b0BEd0c",
      "0x3bEa6d635adc88d2E9154Da832B85E04eC2C13e4",
      "0x4159260934FC613bD54852C87E392010d5a42f59",
      "0x876b4047299F6F5F048FdA3265275F1890D2Fa17",
      "0x0D6a32d205748FaB5291022b6164B627db9098ce",
      "0x5965984bb4492f7556D19A0548d2a2e632641b57",
      "0x2886355D4eF1d8BEFEAD712FD552c95F5f8652fE",
      "0x06C0207f568C3A71792f1Ea58028f5B7F0CeB2D3",
      "0x1B9194286b93344d8dc52386bd2260E2f8b68C63",
      "0x3bEa6d635adc88d2E9154Da832B85E04eC2C13e4",
      "0xfE0b993Ff1a5fC799c26b6d9D6f06AC934483fB6",
      "0x3BE13A452dc9DA9f7D9943881E7110F57FABd805",
      "0xdeA9E71c4275BA4382eB211E7fDE06ee7E1CfA15",
      "0x3197e105Bac6735B2f593A265f6147f133ece255",
      "0x35d08E13109EbC5E3ECD66b43Aa49128d087aEc5",
      "0x4c0f19872882D927bFFA474544bE314F7451505F",
      "0x12f02F9A16a4914C36cF216124198df258104511",
      "0x21D49D54CF5596490E64CaA8C88B18Cd97389564",
      "0xf5132C14Aef60431b161cf8F9fE5F4f00E9131b0",
      "0x259CFaec166e787abd75E5073EbD8c37B62e744c",
      "0x54A28DEF05D9041b83Ba8aAE57722d13e7b5FaE3",
      "0x3bEa6d635adc88d2E9154Da832B85E04eC2C13e4",
      "0xeF213d2FA37910918f0bc753f421D630E3Ce4E9a",
      "0x074Ef40552eCD646A84de1A63A2ADB3f2C7007e0",
      "0x3bEa6d635adc88d2E9154Da832B85E04eC2C13e4",
      "0xb802c4307Cf9Cc26705b0552e9f83B6F27ef7f34",
      "0xBEC2cC2930049067D91Fa16B4e3aa832F0Ee32F9",
      "0x9053b593d4f3a35f2f02cc10f47c4d8e0eb0e7d7",
      "0xF38b6625837fD0B4c1e99eAb53B0aC238D822296",
      "0x3bea6d635adc88d2e9154da832b85e04ec2c13e4",
      "0xb3F7cf46ade4BC42d4CA6061Da56863A105Bd7a2",
      "0xc34485259497923166FcA9e9E87Ad49121D4C2Ea",
      "0x907c3083315a575E1f7dc7f763D861E00775C2ce",
      "0x41501a6903C356F3A81f65D780fF4E8986e3fbf7",
      "0x34360d0B6452D9b1efb392185e9E3195118f768C",
      "0xf1413Cd49b793D9B439ee1bbda13f83Cdb185737",
      "0x593FD817369ebCc7aBa7e5567e45C5722225F807",
      "0x25a24aBcA5070A06594B9431A7C50a9BB650E230",
      "0x232C1159B95B2C287BAe80860347B9558f64a48C",
      "0x1A2AF2D068d9968718F6A838d9E633705c017282",
      "0x562008Ee0C54E62cA13dd1C9ca3225Ed2C90FD10",
      "0x41a628e093ec56bb1eee0c89a5b43664e4441a8e",
      "0x337d49058418c74414c7F56de2ADCdcB1bf53089",
      "0x70eEE162367ac501764D5516B95c4402d9210B8F",
      "0x792c113e14960515fE3c52D46435d6cdb7Ba197B",
      "0x9d3065e078Bfbc51EB8a4F67C49038f234511A4c",
      "0xED9262c9C151812C9F9B496D7A118b6FF391A6fB",
      "0x3705e0421E1573c74703679ffed96d71658F7035",
      "0x2662F1c56018fc94b4201E0258bC44864a0d8642",
      "0x81d99a361B3F2Ae84c7a6abeC61eB670A482c8e0",
      "0xc34b8AC23F55FFCFCAD8b6925818F9540a6e9fC6",
      "0x41e2Fa8D15ba8E348220f380d382f6E2b31c571f",
      "0x8daCB0C16acA5162CBDFbF64FBF9F3B627906798",
      "0x7797F93BBCc8FF514Bdc69112f0473650a4cFB78",
      "0x40227EcAee2Daf2E43Acb77C61eaB2B50c1728e3",
      "0xafAb04Cf1F56109b1559377c17E002D0F5382114",
      "0x77fF15a365049839d74dA8F2821C89f4f5178C28",
      "0xfE0b993Ff1a5fC799c26b6d9D6f06AC934483fB6",
      "0x81d99a361B3F2Ae84c7a6abeC61eB670A482c8e0",
      "0x682f15c5f9128C5e7396F314Bd3fc637Fd8bee7E",
      "0x3E303F957Ea2D17cc31B4653063767d8c56fD103",
      "0x189B9a15F7184409F3F952fC21D2CE85799645f2",
      "0x7b1b0db7ed528908f6cd601fbe54c84bfead881e",
      "0x7b1b0db7ed528908f6cd601fbe54c84bfead881e",
      "0x55Be8a4AC6e364fF4212e5A12eD5ce32DFf01ff9",
      "0x43B7AE15BC3Da89e9Fd755d77F532555CDEbf35D",
      "0xF30Eea37313Cf59D67448346F8319826c1B131c6",
      "0xBDB4E8B07BA3113070F971f1B6A62573271cCC35",
      "0x1EeF41E34BE271F953730033DEA62781C1DCea3F",
      "0x06Fde15154df35A6679Fe1bDBF497F5BbdA3df0d",
      "0xBDB4E8B07BA3113070F971f1B6A62573271cCC35",
      "0x44814b66db62FEb7035a6A32b8A78A2708d32653",
      "0x06Fde15154df35A6679Fe1bDBF497F5BbdA3df0d",
      "0x21EB4968C129D7cb27f0A70CB638f9e9a426cc96",
      "0x8D3b02abccdA1161c98bD95575541bF76C178Ba5",
      "0x299e8d5d972358145fa4794f230b59ba0ef8b4c6",
      "0x68B381dDaf9697519C0E79D61353Ab2e7bE575fc",
      "0x06fde15154df35a6679fe1bdbf497f5bbda3df0d",
      "0x44814b66db62feb7035a6a32b8a78a2708d32653",
      "0x299e8d5d972358145fa4794f230b59ba0ef8b4c6",
      "0x1eef41e34be271f953730033dea62781c1dcea3f",
      "0xaaf8f382b355fb72bdb158772e17f07bb6704c04",
      "0x12f09af31d0781dee57a867016ba9c775f161851",
      "0x06fde15154df35a6679fe1bdbf497f5bbda3df0d",
      "0x1eef41e34be271f953730033dea62781c1dcea3f",
      "0xaaf8f382b355fb72bdb158772e17f07bb6704c04",
      "0x12f09af31d0781dee57a867016ba9c775f161851",
      "0xbCb14cE9B2CA885F73856015AEcB1E11a0Ae9D02",
      "0x44814b66db62feb7035a6a32b8a78a2708d32653",
      "0x62445acf09b33f116bd3c0b34ffca05b6a2f20ce",
      "0xaaf8f382b355fb72bdb158772e17f07bb6704c04",
      "0xDbEb5Fe85212f330dE40854F983785f08A3adb4e",
      "0xaaf8f382b355fb72bdb158772e17f07bb6704c04",
      "0x3E52a87B7E2391d7E4d66c38c3C271a9898eC909",
      "0x41E56583F216df303E830b9BAD9833e2DDC15E41",
      "0xaaf8f382b355fb72bdb158772e17f07bb6704c04",
      "0x21c8ED9440D73Bf45B7e5d5345713402be160e23",
      "0x34360d0B6452D9b1efb392185e9E3195118f768C",
      "0x06fde15154df35a6679fe1bdbf497f5bbda3df0d",
      "0xFdb60798f4Ba6Cdf8059a91BE3Adc12b45051214",
      "0x1eef41e34be271f953730033dea62781c1dcea3f",
      "0x8d3b02abccda1161c98bd95575541bf76c178ba5",
      "0x95d5ede5182c0dD41792aB8ca4812c8B8f850e12",
      "0x12f09af31d0781dee57a867016ba9c775f161851",
      "0x299e8d5d972358145fa4794f230b59ba0ef8b4c6",
      "0x12f09af31d0781dee57a867016ba9c775f161851",
      "0x1eef41e34be271f953730033dea62781c1dcea3f",
      "0x49E15aF2fC5a82637Bb167813EB7523bb8774a04",
      "0x49E15aF2fC5a82637Bb167813EB7523bb8774a04",
      "0xe5dc2885447e958b02c3933231fdf4945e85bef8",
      "0xf5a334a5c1f34c898acec74692a1d7b946c14466",
      "0x299e8d5d972358145fa4794f230b59ba0ef8b4c6",
      "0x1eef41e34be271f953730033dea62781c1dcea3f",
      "0xbCb14cE9B2CA885F73856015AEcB1E11a0Ae9D02",
      "0x44814b66db62feb7035a6a32b8a78a2708d32653",
      "0x03d448C11C755C1F0d751657Ef13D6bb1479B99B",
      "0xc02E1f5740db349623dabA1a00d677Ff74656dBB",
      "0x12f09af31d0781dee57a867016ba9c775f161851",
      "0x1eef41e34be271f953730033dea62781c1dcea3f",
      "0xA52cA06d2b1ba47841540E5f6ea21E1A64F04d11",
      "0x660cA76044B0a1334aB3Fc1aA1bdf53fAffE09EB",
      "0x511f0f61c18f3afd804b40f4c7b9953790ca78c0",
      "0xeec7EE41c54510eed9e65A0266AE5d4f2D0274Dd",
      "0x8d3b02abccda1161c98bd95575541bf76c178ba5",
      "0x1eef41e34be271f953730033dea62781c1dcea3f",
      "0x40D67A5325c3A643A2B5F7752EeEAc172f60Ed0A",
      "0xaa956fa28f169c8c80f9abd7dedde6f65216001b",
      "0x3bea6d635adc88d2e9154da832b85e04ec2c13e4",
      "0xaa956fa28f169c8c80f9abd7dedde6f65216001b",
      "0x44814b66db62feb7035a6a32b8a78a2708d32653",
      "0x3bea6d635adc88d2e9154da832b85e04ec2c13e4",
      "0x5c8B242Ff83Ca756Fe8565e0202B8E78Fd4127D9",
      "0x321e0da663ea9d08c75fa4f9fd18979600ea8a9b",
      "0xe53eb6edf8417b2733b721acde61a6cab9495a8a",
      "0x7cDdc93B3846542610248AB9d3A45610F3211c5A",
      "0x7cDdc93B3846542610248AB9d3A45610F3211c5A",
      "0xfe0b993ff1a5fc799c26b6d9d6f06ac934483fb6",
      "0xfe0b993ff1a5fc799c26b6d9d6f06ac934483fb6",
      "0x033fd4DE9057B3F07815848A370f2AA6fA28d545",
      "0x4d47a056B4cb570f4271FaF8f0a85C83b8C11b04",
      "0xf5a334a5c1f34c898acec74692a1d7b946c14466",
      "0xe6cbCA1C9C0869f3a0f852F0C70866976Ee8545D",
      "0x911A68A0c4593966370b0f1DF6dC43dCb74B3986",
      "0x5D85F24cbC841520c69bBdcc01479E69BF022a3B",
      "0xFF5aDD5A2142e77a6E6956EcEC8BbC27f93adBDE",
      "0x9aEE9816203E84eb7ECEC32b7aA629707513665B",
      "0x2Ef3062036Bd52131DEc0f48fFd897DEC2F971c4",
      "0xc2222d0416621BA4c8aFEc2F32D9bf06832e0156",
      "0x80df4AA77Ef6C5314c7D0F0Ff8E3CAe3D0e5482B",
      "0x25a24aBcA5070A06594B9431A7C50a9BB650E230",
      "0x62445aCF09B33F116BD3c0B34ffca05B6a2f20cE",
      "0x527400ce8EC2DEB33DB82eBA4F0b1f69A37661c5",
      "0xDF35C91Aa096dbFF76784DADFAbaBb80e0E1d08F",
      "0x6487887DE125C9C7F3e30ec7664288729899B16E",
      "0x77c32697ae5dcc8b29f4db8419b20a0d78be6e49",
      "0x54a4ae347bc552da00d7369ef0be5051cb3d8aeb",
      "0x9aEE9816203E84eb7ECEC32b7aA629707513665B",
      "0x5c8b242ff83ca756fe8565e0202b8e78fd4127d9",
      "0x8d3b02abccda1161c98bd95575541bf76c178ba5",
      "0x44814b66db62feb7035a6a32b8a78a2708d32653",
      "0x366B5DCA2221fc97456079fBb4f4B61C16C523AA",
    ];

    if (walletConnected) {
      const web3 = new Web3(Web3.givenProvider);
      await Web3.givenProvider.enable();

      const price = 0 * mintQuantity;
      var tokens = web3.utils.toWei(price.toString(), "ether");
      var bntokens = web3.utils.toBN(tokens);

      const contract = new web3.eth.Contract(
        [
          { inputs: [], stateMutability: "nonpayable", type: "constructor" },
          {
            inputs: [],
            name: "ApprovalCallerNotOwnerNorApproved",
            type: "error",
          },
          {
            inputs: [],
            name: "ApprovalQueryForNonexistentToken",
            type: "error",
          },
          { inputs: [], name: "ApprovalToCurrentOwner", type: "error" },
          { inputs: [], name: "ApproveToCaller", type: "error" },
          { inputs: [], name: "BalanceQueryForZeroAddress", type: "error" },
          { inputs: [], name: "MintToZeroAddress", type: "error" },
          { inputs: [], name: "MintZeroQuantity", type: "error" },
          { inputs: [], name: "OwnerQueryForNonexistentToken", type: "error" },
          {
            inputs: [],
            name: "TransferCallerNotOwnerNorApproved",
            type: "error",
          },
          { inputs: [], name: "TransferFromIncorrectOwner", type: "error" },
          {
            inputs: [],
            name: "TransferToNonERC721ReceiverImplementer",
            type: "error",
          },
          { inputs: [], name: "TransferToZeroAddress", type: "error" },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
              },
              {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
              },
            ],
            name: "Approval",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
              },
              {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
              },
            ],
            name: "ApprovalForAll",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
              },
            ],
            name: "OwnershipTransferred",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
              },
            ],
            name: "Transfer",
            type: "event",
          },
          {
            inputs: [{ internalType: "address", name: "", type: "address" }],
            name: "addressPublicSaleMintedBalance",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [{ internalType: "address", name: "", type: "address" }],
            name: "addressWhitelistSaleMintedBalance",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "approve",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "owner", type: "address" },
            ],
            name: "balanceOf",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "baseURI",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "getApproved",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "owner", type: "address" },
              { internalType: "address", name: "operator", type: "address" },
            ],
            name: "isApprovedForAll",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes32[]", name: "proof", type: "bytes32[]" },
              { internalType: "bytes32", name: "leaf", type: "bytes32" },
            ],
            name: "isValidWhitelistSaleMerkleTreeProof",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "maxSupply",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "name",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "nftPublicSalePerAddressLimit",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "nftWhitelistSalePerAddressLimit",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "owner",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "ownerMint",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "_receiver", type: "address" },
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "ownerMintForOthers",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "ownerOf",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "paused",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "publicSaleCost",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "publicSaleMint",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
          {
            inputs: [],
            name: "renounceOwnership",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "safeTransferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
              { internalType: "bytes", name: "_data", type: "bytes" },
            ],
            name: "safeTransferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "operator", type: "address" },
              { internalType: "bool", name: "approved", type: "bool" },
            ],
            name: "setApprovalForAll",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "string", name: "_uri", type: "string" }],
            name: "setBaseURI",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_supply", type: "uint256" },
            ],
            name: "setMaxSupply",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_limit", type: "uint256" },
            ],
            name: "setNFTPublicSalePerAddressLimit",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_limit", type: "uint256" },
            ],
            name: "setNFTWhitelistSalePerAddressLimit",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "bool", name: "_state", type: "bool" }],
            name: "setPaused",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_cost", type: "uint256" },
            ],
            name: "setPublicSaleCost",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "bool", name: "_state", type: "bool" }],
            name: "setWhitelistSale",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_cost", type: "uint256" },
            ],
            name: "setWhitelistSaleCost",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes32", name: "_root", type: "bytes32" },
            ],
            name: "setWhitelistSaleMerkleRoot",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes4", name: "interfaceId", type: "bytes4" },
            ],
            name: "supportsInterface",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "symbol",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_tokenId", type: "uint256" },
            ],
            name: "tokenURI",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "totalSupply",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "transferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "newOwner", type: "address" },
            ],
            name: "transferOwnership",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "_owner", type: "address" },
            ],
            name: "walletOfOwner",
            outputs: [
              { internalType: "uint256[]", name: "", type: "uint256[]" },
            ],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSale",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSaleCost",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSaleMerkleTreeRoot",
            outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
              {
                internalType: "bytes32[]",
                name: "_merkleTreeProof",
                type: "bytes32[]",
              },
            ],
            name: "whitelistSaleMint",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
          {
            inputs: [],
            name: "withdraw",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
        ],
        "0x71C6f27A537A81d2329eFa619a78FD6e46c9d7A0"
      );

      const addresses = await web3.eth.getAccounts();
      const address = addresses[0];

      const leaves = WHITELIST_SALE_WHITELIST.map((x) => keccak256(x));
      const tree = new MerkleTree(leaves, keccak256, { sortPairs: true });
      const buf2hex = (x) => "0x" + x.toString("hex");

      const leaf = keccak256(address);
      const proof = tree.getProof(leaf).map((x) => buf2hex(x.data));

      if (WHITELIST_SALE_WHITELIST.indexOf(address) !== -1) {
        contract.methods
          .totalSupply()
          .call()
          .then((totalSupply) => {
            if (totalSupply + mintQuantity <= 1500) {
              contract.methods
                .whitelistSaleMint(mintQuantity, proof)
                .send({
                  gas: "300000",
                  maxPriorityFeePerGas: "35000000000",
                  from: address,
                  value: bntokens,
                })
                .then(() => {
                  toast.error("Minted successfully");

                  contract.methods
                    .totalSupply()
                    .call()
                    .then((response) => {
                      setTotalMinted(response);
                    });
                });
            } else {
              toast.error("Whitelist sale is end");
            }
          });
      } else {
        toast.error("You are not whitelisted");
      }
    }
  };

  const fetchMyNFTs = async () => {
    setMyNFTs([]);

    if (walletConnected) {
      const web3 = new Web3(Web3.givenProvider);
      await Web3.givenProvider.enable();

      const contract = new web3.eth.Contract(
        [
          { inputs: [], stateMutability: "nonpayable", type: "constructor" },
          {
            inputs: [],
            name: "ApprovalCallerNotOwnerNorApproved",
            type: "error",
          },
          {
            inputs: [],
            name: "ApprovalQueryForNonexistentToken",
            type: "error",
          },
          { inputs: [], name: "ApprovalToCurrentOwner", type: "error" },
          { inputs: [], name: "ApproveToCaller", type: "error" },
          { inputs: [], name: "BalanceQueryForZeroAddress", type: "error" },
          { inputs: [], name: "MintToZeroAddress", type: "error" },
          { inputs: [], name: "MintZeroQuantity", type: "error" },
          { inputs: [], name: "OwnerQueryForNonexistentToken", type: "error" },
          {
            inputs: [],
            name: "TransferCallerNotOwnerNorApproved",
            type: "error",
          },
          { inputs: [], name: "TransferFromIncorrectOwner", type: "error" },
          {
            inputs: [],
            name: "TransferToNonERC721ReceiverImplementer",
            type: "error",
          },
          { inputs: [], name: "TransferToZeroAddress", type: "error" },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
              },
              {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
              },
            ],
            name: "Approval",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
              },
              {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
              },
            ],
            name: "ApprovalForAll",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
              },
            ],
            name: "OwnershipTransferred",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
              },
            ],
            name: "Transfer",
            type: "event",
          },
          {
            inputs: [{ internalType: "address", name: "", type: "address" }],
            name: "addressPublicSaleMintedBalance",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [{ internalType: "address", name: "", type: "address" }],
            name: "addressWhitelistSaleMintedBalance",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "approve",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "owner", type: "address" },
            ],
            name: "balanceOf",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "baseURI",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "getApproved",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "owner", type: "address" },
              { internalType: "address", name: "operator", type: "address" },
            ],
            name: "isApprovedForAll",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes32[]", name: "proof", type: "bytes32[]" },
              { internalType: "bytes32", name: "leaf", type: "bytes32" },
            ],
            name: "isValidWhitelistSaleMerkleTreeProof",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "maxSupply",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "name",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "nftPublicSalePerAddressLimit",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "nftWhitelistSalePerAddressLimit",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "owner",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "ownerMint",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "_receiver", type: "address" },
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "ownerMintForOthers",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "ownerOf",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "paused",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "publicSaleCost",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "publicSaleMint",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
          {
            inputs: [],
            name: "renounceOwnership",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "safeTransferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
              { internalType: "bytes", name: "_data", type: "bytes" },
            ],
            name: "safeTransferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "operator", type: "address" },
              { internalType: "bool", name: "approved", type: "bool" },
            ],
            name: "setApprovalForAll",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "string", name: "_uri", type: "string" }],
            name: "setBaseURI",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_supply", type: "uint256" },
            ],
            name: "setMaxSupply",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_limit", type: "uint256" },
            ],
            name: "setNFTPublicSalePerAddressLimit",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_limit", type: "uint256" },
            ],
            name: "setNFTWhitelistSalePerAddressLimit",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "bool", name: "_state", type: "bool" }],
            name: "setPaused",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_cost", type: "uint256" },
            ],
            name: "setPublicSaleCost",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "bool", name: "_state", type: "bool" }],
            name: "setWhitelistSale",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_cost", type: "uint256" },
            ],
            name: "setWhitelistSaleCost",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes32", name: "_root", type: "bytes32" },
            ],
            name: "setWhitelistSaleMerkleRoot",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes4", name: "interfaceId", type: "bytes4" },
            ],
            name: "supportsInterface",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "symbol",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_tokenId", type: "uint256" },
            ],
            name: "tokenURI",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "totalSupply",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "transferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "newOwner", type: "address" },
            ],
            name: "transferOwnership",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "_owner", type: "address" },
            ],
            name: "walletOfOwner",
            outputs: [
              { internalType: "uint256[]", name: "", type: "uint256[]" },
            ],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSale",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSaleCost",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSaleMerkleTreeRoot",
            outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
              {
                internalType: "bytes32[]",
                name: "_merkleTreeProof",
                type: "bytes32[]",
              },
            ],
            name: "whitelistSaleMint",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
          {
            inputs: [],
            name: "withdraw",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
        ],
        "0x71C6f27A537A81d2329eFa619a78FD6e46c9d7A0"
      );

      const addresses = await web3.eth.getAccounts();
      const address = addresses[0];

      contract.methods
        .walletOfOwner(address)
        .call()
        .then((nfts) => {
          nfts.forEach((nft) => {
            contract.methods
              .tokenURI(nft)
              .call()
              .then((nftTokenURI) => {
                axios
                  .post(
                    `../../collection/jsons/${nft}.json`
                  )
                  .then((res) => {
                    setMyNFTs((prev) => {
                      return [
                        ...prev,
                        {
                          ...res.data,
                          edition: nft,
                          revealed:
                            nftTokenURI !==
                            "../../collection/placeholder.json",
                        },
                      ];
                    });
                  });
              });
          });
        });
    }
  };

  const reveal = async (tokenID) => {
    if (walletConnected) {
      const web3 = new Web3(Web3.givenProvider);
      await Web3.givenProvider.enable();

      const contract = new web3.eth.Contract(
        [
          { inputs: [], stateMutability: "nonpayable", type: "constructor" },
          {
            inputs: [],
            name: "ApprovalCallerNotOwnerNorApproved",
            type: "error",
          },
          {
            inputs: [],
            name: "ApprovalQueryForNonexistentToken",
            type: "error",
          },
          { inputs: [], name: "ApprovalToCurrentOwner", type: "error" },
          { inputs: [], name: "ApproveToCaller", type: "error" },
          { inputs: [], name: "BalanceQueryForZeroAddress", type: "error" },
          { inputs: [], name: "MintToZeroAddress", type: "error" },
          { inputs: [], name: "MintZeroQuantity", type: "error" },
          { inputs: [], name: "OwnerQueryForNonexistentToken", type: "error" },
          {
            inputs: [],
            name: "TransferCallerNotOwnerNorApproved",
            type: "error",
          },
          { inputs: [], name: "TransferFromIncorrectOwner", type: "error" },
          {
            inputs: [],
            name: "TransferToNonERC721ReceiverImplementer",
            type: "error",
          },
          { inputs: [], name: "TransferToZeroAddress", type: "error" },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
              },
              {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
              },
            ],
            name: "Approval",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
              },
              {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
              },
            ],
            name: "ApprovalForAll",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
              },
            ],
            name: "OwnershipTransferred",
            type: "event",
          },
          {
            anonymous: false,
            inputs: [
              {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
              },
            ],
            name: "Transfer",
            type: "event",
          },
          {
            inputs: [{ internalType: "address", name: "", type: "address" }],
            name: "addressPublicSaleMintedBalance",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [{ internalType: "address", name: "", type: "address" }],
            name: "addressWhitelistSaleMintedBalance",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "approve",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "owner", type: "address" },
            ],
            name: "balanceOf",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "baseURI",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "getApproved",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "owner", type: "address" },
              { internalType: "address", name: "operator", type: "address" },
            ],
            name: "isApprovedForAll",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes32[]", name: "proof", type: "bytes32[]" },
              { internalType: "bytes32", name: "leaf", type: "bytes32" },
            ],
            name: "isValidWhitelistSaleMerkleTreeProof",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "maxSupply",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "name",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "nftPublicSalePerAddressLimit",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "nftWhitelistSalePerAddressLimit",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "owner",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "ownerMint",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "_receiver", type: "address" },
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "ownerMintForOthers",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "ownerOf",
            outputs: [{ internalType: "address", name: "", type: "address" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "paused",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "publicSaleCost",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
            ],
            name: "publicSaleMint",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
          {
            inputs: [],
            name: "renounceOwnership",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "safeTransferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
              { internalType: "bytes", name: "_data", type: "bytes" },
            ],
            name: "safeTransferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "operator", type: "address" },
              { internalType: "bool", name: "approved", type: "bool" },
            ],
            name: "setApprovalForAll",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "string", name: "_uri", type: "string" }],
            name: "setBaseURI",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_supply", type: "uint256" },
            ],
            name: "setMaxSupply",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_limit", type: "uint256" },
            ],
            name: "setNFTPublicSalePerAddressLimit",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_limit", type: "uint256" },
            ],
            name: "setNFTWhitelistSalePerAddressLimit",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "bool", name: "_state", type: "bool" }],
            name: "setPaused",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_cost", type: "uint256" },
            ],
            name: "setPublicSaleCost",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [{ internalType: "bool", name: "_state", type: "bool" }],
            name: "setWhitelistSale",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_cost", type: "uint256" },
            ],
            name: "setWhitelistSaleCost",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes32", name: "_root", type: "bytes32" },
            ],
            name: "setWhitelistSaleMerkleRoot",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "bytes4", name: "interfaceId", type: "bytes4" },
            ],
            name: "supportsInterface",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "symbol",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_tokenId", type: "uint256" },
            ],
            name: "tokenURI",
            outputs: [{ internalType: "string", name: "", type: "string" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "totalSupply",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "from", type: "address" },
              { internalType: "address", name: "to", type: "address" },
              { internalType: "uint256", name: "tokenId", type: "uint256" },
            ],
            name: "transferFrom",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "newOwner", type: "address" },
            ],
            name: "transferOwnership",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
          {
            inputs: [
              { internalType: "address", name: "_owner", type: "address" },
            ],
            name: "walletOfOwner",
            outputs: [
              { internalType: "uint256[]", name: "", type: "uint256[]" },
            ],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSale",
            outputs: [{ internalType: "bool", name: "", type: "bool" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSaleCost",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [],
            name: "whitelistSaleMerkleTreeRoot",
            outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
            stateMutability: "view",
            type: "function",
          },
          {
            inputs: [
              { internalType: "uint256", name: "_mintAmount", type: "uint256" },
              {
                internalType: "bytes32[]",
                name: "_merkleTreeProof",
                type: "bytes32[]",
              },
            ],
            name: "whitelistSaleMint",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
          {
            inputs: [],
            name: "withdraw",
            outputs: [],
            stateMutability: "payable",
            type: "function",
          },
        ],
        "0x71C6f27A537A81d2329eFa619a78FD6e46c9d7A0"
      );

      const addresses = await web3.eth.getAccounts();
      const address = addresses[0];

      setRevealNFT({
        ...revealNFT,
        tokenID,
        revealing: true,
        revealed: false,
      });

      contract.methods
        .revealNFT(tokenID)
        .send({
          gasLimit: "300000",
          from: address,
        })
        .then(() => {
          setRevealNFT({
            ...revealNFT,
            tokenID,
            revealing: false,
            revealed: true,
          });

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(() => {
          setRevealNFT({
            ...revealNFT,
            revealing: false,
            revealed: false,
          });

          toast.error("Something went wrong");
        });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer
        theme="colored"
        position="bottom-right"
        autoClose={1000}
      />

      <BrowserRouter>
        <Scroller />

        <NavigationBar
          language={language}
          setLanguage={setLanguage}
          connectWallet={connectWallet}
          walletConnected={walletConnected}
        />

        <Switch>
          <Route path="/" exact>
            <Landing language={language} />
          </Route>

          <Route path="/about" exact>
            <About language={language} />
          </Route>

          <Route path="/gallery" exact>
            <Gallery language={language} />
          </Route>

          <Route path="/schedule" exact>
            <Roadmap language={language} />
          </Route>

          <Route path="/faqs" exact>
            <FAQs language={language} />
          </Route>

          <Route path="/roadmap" exact>
            <Roadmap language={language} />
          </Route>

          <Route path="/team" exact>
            <Team language={language} />
          </Route>

          <Route path="/mint">
            <Mint
              connectWallet={connectWallet}
              walletConnected={walletConnected}
              totalMinted={totalMinted}
              mintQuantity={mintQuantity}
              setMintQuantity={setMintQuantity}
              whitelistSaleMint={whitelistSaleMint}
            />
          </Route>

          <Route path="/my-nfts">
            <MyNFTs
              walletConnected={walletConnected}
              myNFTs={myNFTs}
              fetchMyNFTs={fetchMyNFTs}
              revealNFT={revealNFT}
              reveal={reveal}
            />
          </Route>

          <Route path="/admin">
            <Admin />
          </Route>
        </Switch>
      </BrowserRouter>
    </React.Fragment>
  );
};

// Export
export default App;
